/**
 * Dynamic Tambola 3x9 ticket generator.
 * Row rules: Exactly 5 numbers and 4 blanks.
 * Column rules: Distributed column ranges (Col 0: 1-9, Col 1: 10-19, ..., Col 8: 80-90)
 * Each column has at least 1 number, vertically sorted.
 */
export function generateTambolaTicket(): number[][] {
  const grid: number[][] = Array.from({ length: 3 }, () => Array(9).fill(0));

  const colRanges = [
    { min: 1, max: 9 },
    { min: 10, max: 19 },
    { min: 20, max: 29 },
    { min: 30, max: 39 },
    { min: 40, max: 49 },
    { min: 50, max: 59 },
    { min: 60, max: 69 },
    { min: 70, max: 79 },
    { min: 80, max: 90 },
  ];

  const colNumbers: number[][] = colRanges.map((range) => {
    const list: number[] = [];
    while (list.length < 3) {
      const num = Math.floor(Math.random() * (range.max - range.min + 1)) + range.min;
      if (!list.includes(num)) list.push(num);
    }
    return list.sort((a, b) => a - b);
  });

  let success = false;
  let attempts = 0;

  while (!success && attempts < 100) {
    attempts++;
    for (let r = 0; r < 3; r++) {
      grid[r]!.fill(0);
    }

    const rowCols: number[][] = [];
    for (let r = 0; r < 3; r++) {
      const cols: number[] = [];
      while (cols.length < 5) {
        const c = Math.floor(Math.random() * 9);
        if (!cols.includes(c)) cols.push(c);
      }
      rowCols.push(cols);
    }

    const colCounts = Array(9).fill(0);
    for (let r = 0; r < 3; r++) {
      for (const c of rowCols[r]!) {
        colCounts[c]++;
      }
    }

    if (colCounts.every((count) => count >= 1 && count <= 3)) {
      const colIndices = Array(9).fill(0);
      for (let r = 0; r < 3; r++) {
        for (const c of rowCols[r]!) {
          const idx = colIndices[c];
          grid[r]![c] = colNumbers[c]![idx]!;
          colIndices[c]++;
        }
      }

      for (let c = 0; c < 9; c++) {
        const verticalNums: number[] = [];
        for (let r = 0; r < 3; r++) {
          if (grid[r]![c] !== 0) {
            verticalNums.push(grid[r]![c]!);
          }
        }
        verticalNums.sort((a, b) => a - b);
        let idx = 0;
        for (let r = 0; r < 3; r++) {
          if (grid[r]![c] !== 0) {
            grid[r]![c] = verticalNums[idx]!;
            idx++;
          }
        }
      }

      success = true;
    }
  }

  if (!success) {
    return [
      [4, 12, 0, 38, 0, 52, 0, 0, 82],
      [0, 0, 25, 0, 42, 0, 63, 70, 85],
      [7, 0, 29, 0, 47, 58, 0, 78, 0],
    ];
  }

  return grid;
}
export default generateTambolaTicket;
